import React, { useMemo, useState } from "react";
import "../assets/css/InstagramReelCard.css";

function linkify(text) {
  if (!text) return [];
  const out = [];
  const re = /((https?:\/\/[^\s]+)|#([\p{L}\p{N}_]+)|@([\p{L}\p{N}._]+))/gu;
  let last = 0;
  for (const m of text.matchAll(re)) {
    const [full, url, http, hash, mention] = m;
    if (m.index > last) out.push(text.slice(last, m.index));
    if (http) {
      out.push(<a key={m.index} href={url} target="_blank" rel="noopener noreferrer">{url}</a>);
    } else if (hash) {
      out.push(<a key={m.index} href={`https://www.instagram.com/explore/tags/${hash}/`} target="_blank" rel="noopener noreferrer" className="igc-hash">#{hash}</a>);
    } else if (mention) {
      out.push(<a key={m.index} href={`https://www.instagram.com/${mention}/`} target="_blank" rel="noopener noreferrer" className="igc-mention">@{mention}</a>);
    }
    last = m.index + full.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export default function InstagramReelCard({
  username = "franko.gustavo.argandona",
  displayName = "franko.gustavo.argandona",
  avatarUrl,
  profileUrl = "https://www.instagram.com/franko.gustavo.argandona/",
  media = { type: "video", src: "", poster: "", ratio: "4 / 5", alt: "" },
  caption = "",
  timeLabel = "",
  externalLink = "",
  location,
  className,
  style
}) {
  const [expanded, setExpanded] = useState(false);
  const captionParts = useMemo(() => linkify(caption), [caption]);
  const isVideo = media?.type === "video";

  return (
    <article className={`igc-card ${className || ""}`} style={style}>
      <header className="igc-header">
        <a
          className="igc-avatar"
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ backgroundImage: avatarUrl ? `url(${avatarUrl})` : undefined }}
        />
        <div className="igc-user">
          <a className="igc-name" href={profileUrl} target="_blank" rel="noopener noreferrer">
            {username}
          </a>
          {!!location && <div className="igc-loc">{location}</div>}
        </div>
        <a className="igc-cta" href={profileUrl} target="_blank" rel="noopener noreferrer">
          View profile
        </a>
      </header>

      <div className="igc-media" style={{ aspectRatio: "16 / 9" }}>
        {isVideo ? (
          <video
            className="igc-video"
            src={media.src}
            poster={media.poster}
            controls
            playsInline
            preload="metadata"
          />
        ) : (
          <img className="igc-image" src={media.src} alt={media.alt || ""} loading="lazy" />
        )}
      </div>

      {(caption || timeLabel || externalLink) && (
        <div className="igc-meta">
          {caption && (
            <div className="igc-caption">
              <a className="igc-caption-user" href={profileUrl} target="_blank" rel="noopener noreferrer">
                {username}
              </a>{" "}
              <span className="igc-caption-text">
                {expanded ? captionParts : (
                  <>
                    {linkify(caption.slice(0, 140))}
                    {caption.length > 140 ? "…" : ""}
                  </>
                )}
              </span>
              {caption.length > 140 && (
                <button className="igc-more" onClick={() => setExpanded(v => !v)}>
                  {expanded ? "less" : "more"}
                </button>
              )}
            </div>
          )}

          {externalLink && (
            <div className="igc-linkrow">
              <a href={externalLink} target="_blank" rel="noopener noreferrer">
                View more on Instagram
              </a>
            </div>
          )}
        </div>
      )}
    </article>
  );
}
